import useEventHub from './EventHub.component';

export default useEventHub;
export type { EventHubEvent } from './EventHub.types';
export {
  EditorEventTypes,
  ScrollPositions,
  ZoomEmitValues
} from './EventHub.types';
